import styled from 'styled-components';
import getGradientType from '../../utils/get-Gradient-Types';

interface Props {
  $subject: string;
}

export const Container = styled.div`
  max-width: 100%;
  margin-bottom: 30px;
  margin-top: 30px;

  ${({ theme }) => theme.spacing.articleBody}

  .wrap-image {
    margin-bottom: 0;
    padding: 0 !important;
  }

  .wrap-image .logoImage {
    width: 181px;
    margin-bottom: .5em;
  }

  & > * {
    margin: 1em 0;

    @media (min-width: 768px){
      padding: 0 70px !important;
    }
  }
`;

export const Hr = styled.hr<Props>`
  ${({ $subject: subject, theme }) => getGradientType(subject, theme)};
  margin: 0 auto;
  border: none;
  height: 2px;
  border-radius: 8px;
  padding: 0 !important;
`;
